
import GridBodyRow from './body-row';
import { PositionInOrder } from '../../../../enums';
import { GridSizeStylesProps } from '../../mixins/grid-size-styles';

export default {
  name: 'GridBody',
  components: {
    GridBodyRow,
  },
  mixins: [GridSizeStylesProps],
  props: {
    rows: {
      default: () => [],
      type: Array,
    },
    columns: {
      default: () => [],
      type: Array,
    },
    stickyPositions: {
      default: () => [],
      type: Array,
    },
  },
  methods: {
    getPositionInOrder(index) {
      return index % 2 === 0 ? PositionInOrder.Even : PositionInOrder.Odd;
    },
  },
};
